import * as React from "react";
import { cn } from "@/lib/utils";

interface CircularProgressProps {
  value: number; // 0-100
  size?: number;
  strokeWidth?: number;
  progressColor?: string; // Custom progress color
  backgroundColor?: string; // Custom background color
  className?: string;
  children?: React.ReactNode;
}

export function CircularProgress({
  value,
  size = 200,
  strokeWidth = 12,
  progressColor,
  backgroundColor,
  className,
  children,
}: CircularProgressProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className={cn("relative inline-flex items-center justify-center", className)} style={{ width: size, height: size }}>
      <svg
        className="transform -rotate-90"
        width={size}
        height={size}
      >
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={backgroundColor || "currentColor"}
          strokeWidth={strokeWidth}
          fill="none"
          className={!backgroundColor ? "text-muted/20" : undefined}
        />
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={progressColor || "currentColor"}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className={!progressColor ? "text-primary transition-all duration-1000 ease-out" : "transition-all duration-1000 ease-out"}
        />
      </svg>
      {/* Content */}
      {children && (
        <div className="absolute inset-0 flex items-center justify-center">
          {children}
        </div>
      )}
    </div>
  );
}

